angular.module('rjmNg.common.services').factory('stringService', [
  () ->
    hashCode: (str) ->
      hash = 0
      return hash if str.length is 0
      i = 0
      while i < str.length
        char = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash # Convert to 32bit integer
        i++
      return hash & 0x7FFFFFFF # only return positive numbers

    # Convert a string to title case (e.g. 'foo bar' -> 'Foo Bar', 'COUNT DISTINCT' -> 'Count Distinct')
    # Returns whatever is input if the input is null or undefined
    toTitleCase: (str) ->
      return str unless str?
      str.replace /\w\S*/g, (match) ->
        match.charAt(0).toUpperCase() + match.substr(1).toLowerCase()

    # Escape any special characters in the input string so that unexpected
    # behavior doesn't result when the string is used in a regular expression.
    escapeRegEx: (str) ->
      return if not str? then str else str.replace /([-.*+?^${}()|\[\]\/\\])/g, "\\$1"

    # Remove the escape characters from a regular expression.
    unescapeRegEx: (str) ->
      return if not str? then str else str.replace /\\([-.*+?^${}()|\[\]\/\\])/g, "$1"

    # Given a list of strings and a proposed string, returns a string
    # guaranteed to be unique. In the case of duplicate strings, appendinds a
    # trailing number attempting to take account existing sequences.
    #
    # For example:
    #   getUniqueString(['foo'], 'bar') == 'bar'
    #   getUniqueString(['foo'], 'foo') == 'foo 2'
    #   getUniqueString(['foo 3'], 'foo 2') == 'foo 4'
    #
    getUniqueString: (strings, proposedString) ->
      return null if not proposedString?

      # If the proposed string ends in a number, split that number from the
      # string.
      highestNumber = null
      if stringAndNumber = proposedString.match(/^\s*(.*?)\s+(\d+)\s*$/)
        proposedString = stringAndNumber[1]
        highestNumber = parseInt(stringAndNumber[2]) - 1

      # Find any existing combinations of proposedString + some number.
      # Compile this here for performance reasons.
      safeProposedString = @escapeRegEx(proposedString)
      re = new RegExp("^\\s*#{safeProposedString}\\s+(\\d+)\\s*$")

      for existingString in strings when existingString?
        if existingString.trim() is proposedString
          highestNumber = Math.max(highestNumber, 1)
        else if stringAndNumber = existingString.match(re)
          highestNumber = Math.max(highestNumber, parseInt(stringAndNumber[1]))

      return if highestNumber? then "#{proposedString} #{highestNumber + 1}" else proposedString

    # Checks whether a string is generated based on a substring.
    # Returns true if it is a substring, a space, and an attached number, meaning it is generated. Returns false if this pattern isn't matched.
    # Use case: check whether an alias was generated or a user created it themselves - variables to pass in checkGeneratedString(metric.name, metric.alias)
    checkGeneratedString: (subString, fullString) ->
      indexOfSpace = subString.length

      # check to name sure the alias begins with the subString
      if fullString.indexOf(subString) isnt 0
          return false
      # check to see if there's a space after the name followed by a number, which would follow the generated alias pattern
      else
        return /^\s\d+$/.test(fullString.slice(indexOfSpace))

    # Note: this only works on browers whcih support ES6's codePointAt function.
    # On other browers, this simly returns true.
    allCharactersInBasicMultilingualPlane: (str) ->
      not str?.codePointAt? or [0...str.length].every (index) ->
        str.codePointAt(index) < 0x10000

    # Makes the first letter of the string upper case
    upperCaseFirst: (str) ->
      unless str?
        return ''
      str.charAt(0).toUpperCase() + str.slice(1)

    # Returns truncated string with given length and "..." at the end
    truncateString: (str, length) ->
      return if str.length < length then str else str.slice(0, length-3) + "..."
  ]
)
